import React from 'react'

import SpriteIcon from 'src/components/SpriteIcon'

import addUnit from 'src/utils/addUnit'

const defaultLogo = RAILS_ASSET_URL('/sprites/default-organization-logo.svg')

const DefaultOrganizationLogo = ({ size = 90 }) => {
  const sizeWithUnit = addUnit(size)
  return (
    <SpriteIcon
      icon="heart"
      file={defaultLogo}
      className="default-organization-logo bg-primary text-white align-middle rounded"
      style={{ width: sizeWithUnit, height: sizeWithUnit }}
      aria-hidden="true"
    />
  )
}

export default DefaultOrganizationLogo
